<footer>
    <div class="FfooterInt dOchoM dtDiez dmOnce flx">
        <div class="dCuatro dmDoce Finformacion flx">
            <div class="flx dDoce">
                <div class="dDoce">
                    <span style="font-weight: 700;">OFICINA CORPORATIVA</span><br/>Av. Independencia No. 26, Col. Independencia <br/> Ciudad de México, C.P. 03630<br/><span style="font-weight: 700;">Canal telefónico: </span> 800 911 6666, <i>opción 2 – Consultorios</i>
                </div>
                <br/>
                <div class="dDoce Fredes flx">
                    <div class="dDoce redFfacebook flx">
                        <a href="https://www.facebook.com/FundacionBEST" target="_blank" rel="noopener">
                            <img src="./assets/images/facebook-logo.png" width="48" height="48" alt="facebook">
                        </a>
                        <a href="https://twitter.com/fundacionbest" target="_blank" rel="noopener">
                            <img src="./assets/images/twitter-logo.png" width="48" height="48" alt="twitter">
                        </a>
                        <a href="https://www.youtube.com/channel/UCRXK0asLNwzqlz4JliM-OUw/featured" target="_blank" rel="noopener">
                            <img src="./assets/images/youtube-logo.png" width="48" height="48" alt="youtube">
                        </a>
                        <a href="https://www.instagram.com/fundacionbestmx/" target="_blank" rel="noopener">
                            <img src="./assets/images/ins-logo.png" width="48" height="48" alt="youtube">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="dCuatro dmDoce Finformacion flx">
            <div class="flx dDoce">
                <div class="dDoce footMov">
                    <a routerLink="directorio">
                        <span style="font-weight: 700;">DIRECTORIO</span>
                    </a>
                </div>
                <div class="dDoce">
                    <a href="https://concienciamedica.com.mx/" target="_blank" rel="noopener">
                        <span style="font-weight: 700;">CONCIENCIA MÉDICA</span><br/>Acceso a médicos
                    </a>
                </div>
                <br/>
                <div class="dDoce">
                    <a href="https://facturacfd.fundacionbest.org.mx/CFD_REcepciones_FB/Acceso.aspx" target="_blank" rel="noopener" style="cursor: pointer;">
                        <span style="font-weight: 700;">PROVEEDORES DE<br>BIENES Y SERVICIOS</span>
                    </a>
                </div>
                <div class="dDoce">
                    <a routerLink="ligas-grupo-por-un-pais-mejor">
                        <span style="font-weight: 700;">EMPRESAS E INSTITUCIONES<br>DEL GRUPO POR UN PAÍS MEJOR</span>
                    </a>
                </div>
                <div class="dDoce footMov">
                    <a routerLink="ligas-salud">
                        <span style="font-weight: 700;">LIGAS DE INTERÉS</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="dCuatro dmDoce Finformacion flx">
            <div class="dOcho flx footMov" id="logoPorUnPaisMejor">
                <a href="https://www.porunpaismejor.com.mx/" target="_blank" rel="noopener">
                    <img src="./assets/images/grupoPorUnPaisMejor-logo.svg" width="90%"  alt="logo Grupo por un país mejor a. c.">
                </a>
            </div>
        </div>
    </div>

	<div class="dDoce dmOnce FfooterPleca">© Copyright <span [innerHTML]="year"></span> D.R. Fundación Best A.C. | <a routerLink="aviso-de-privacidad">Aviso de privacidad</a> | <a routerLink="aviso-legal">Aviso legal</a> | <a routerLink="politica-de-cookies">Política de cookies</a></div>

</footer>


<!-- Modal Proveedores -->
<div class="modal-overlay" *ngIf="modalProveedores" (click)="cerrarModalProveedores()">
    <div class="modal-caja" (click)="$event.stopPropagation()">
        <button class="modal-cerrar" (click)="cerrarModalProveedores()">&times;</button>

        <p class="text-modal">Estamos en actualización, en breve se restablece el acceso.</p>

        <p class="cerrar-modal"><a  (click)="cerrarModalProveedores()" rel="noopener" class="modal-boton">
            Cerrar
        </a>
        </p>
    </div>
</div>